var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visibleActive,
          expression: "visibleActive"
        }
      ],
      ref: "tooltip",
      class: ["tooltip", ..._vm.stateClassList],
      attrs: { "data-testid": "tooltip-test" },
      on: {
        click: _vm.tooltipDocumentClick,
        mouseenter: _vm.onMouseEnter,
        mouseleave: _vm.onMouseLeave
      }
    },
    [
      _vm.state
        ? _c("i", {
            class: [
              "icon",
              _vm.state === "negative" && "icon-warning",
              _vm.state === "warning" && "icon-warning-01",
              _vm.state === "positive" && "icon-circle-check"
            ]
          })
        : _vm._e(),
      _vm._t("default", function() {
        return [_vm._v("Tooltip Content")]
      }),
      _c("PopperPosition", {
        attrs: {
          trackedRefName: _vm.trackedRef,
          popoverRefName: _vm.$refs.tooltip,
          placement: _vm.placement,
          popperVisible: _vm.visibleActive,
          trackerWatch: _vm.trackedRefName,
          strategy: _vm.positionStrategy,
          modifiers: _vm.popperModifiers
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }